<template>
  <NewUserEmailForm :user-email="resource"
                    @formSubmit="formSubmitted($event)" />
</template>

<script>
import store from "./UserEmailStore";
import NewUserEmailForm from "./NewUserEmailForm.vue";
import UserEmailMixin from "./UserEmailMixin";

const responseStore = {
  response: {
    resource: {
      hidden: false
    }
  }
};

export default {
  name: "UserEmailNew",

  title () {
    return `New Email - ${Dashboard.currentTenant.name}`;
  },

  components: {
    NewUserEmailForm
  },

  mixins: [UserEmailMixin],

  data: function () {
    return {
      responseStore: this.$_.cloneDeep(responseStore)
    };
  },

  mounted () {
    this.addNewBreadcrumb("Email");
  },

  methods: {
    async formSubmitted (e) {
      this.handleResponseToEdit(await store.create());
    }
  }
};
</script>
